module.exports = __webpack_public_path__ + "img/jiazhang.46ef0b85.png";